export const BLOCK_SETTING_COMMENT =
  /\s*\{([^{}]*)\}\s*(?:\{true\}|\{false\})\s*\{\s*(<[a-z][\s\S]*>)\s*\}\s*\{?([^{}]*)?\}?\s*$/;
